import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import Error from "../error/ErrorPage.js";
import "./LOinfo.css";
import axios from "axios";
import Home from "../../Home.js";
import MortgageGuide from "../MortgageGuide.js";

export default function LOinfo(props) {
	const params = useParams()

	const [Myuser, setMyuser] = useState(null); // Changed from "" to null
	const [loading, setLoading] = useState(true); // Add loading state
	const [error, setError] = useState(false); // Add error state
	const [showMortgage, setShowMortgage] = useState(false);
	
	const location = props.location
	const baseName = props.baseName
	const basePath = props.basePath
	const Footer = props.Footer

	useEffect(() => {
		setLoading(true);
		setError(false);
		
		if (params.LOid === "guides") {
			setShowMortgage(true);
			setLoading(false);
		} else {
			setShowMortgage(false);

			axios.get(process.env.REACT_APP_LODETAILS_CDN_URL)
				.then((response) => {
					if (response && response.status === 200) {
						const data = response.data;
						let userFound = false;
						
						for (let i = 0; i < data.length; i++) {
							if (data[i].url === params.LOid) {
								setMyuser(data[i]);
								userFound = true;
								break;
							}
						}
						
						if (!userFound) {
							setError(true);
						}
					} else {
						setError(true);
					}
				})
				.catch((err) => {
					console.error("Error fetching LO details:", err);
					setError(true);
				})
				.finally(() => {
					setLoading(false);
				});
		}
	}, [params.LOid]); // Add params.LOid to dependency array

	const renderData = () => {
		return (
			<MortgageGuide
				location={location}
				baseName={baseName}
				basePath={basePath}
				Footer={Footer} />
		);
	}

	// Show loading state
	if (loading) {
		return (
			<div style={{ textAlign: 'center', padding: '50px' }}>
				<p>Loading...</p>
			</div>
		);
	}

	// Show error page if there's an error or user not found
	if (error) {
		return <Error />;
	}

	const imgCDNURL = process.env.REACT_APP_LOIMG_CDN_URL;
	
	return (
		<>
			{showMortgage ? renderData() : (
				<div>
					<Home />
					<Container>
						<Row className='caards'>
							<Col xl={6} lg={6} sm={12} xs={12} md={12}>
								<div className="caard">
									<div className='card1'>
										<div>
											<img
												src={imgCDNURL + Myuser.LOimg}
												alt={Myuser.LOname}
												className="Darrylimg" />
										</div>
										<div className="D-info">
											<div className=''>
												<h4 className='contact-title'> {Myuser.LOname} </h4>
											</div>
											<div className='contact-detail'>
												<h6 className='contact-detail1'>NMLS {Myuser.LOid} <br /></h6>
												<h6 className='contact-detail1'>{Myuser.LOpost}</h6>
												<h6 className='contact-detail1'>D:&nbsp;
													<a className='contact-detail1' href={"tel:+1" + Myuser.LOcontact}>
														{Myuser.LOcontact}
													</a>
												</h6>
												<h6 className='contact-detail1'>
													<a className='contact-detail1' href={"mailto:" + Myuser.LOemail}>
														{Myuser.LOemail}
													</a>
												</h6>
												<h6 className='contact-detail1'>
													<a className='contact-detail1' href={"https://" + Myuser.LOwebsite} target='_blank' rel="noopener noreferrer">
														{Myuser.LOwebsite}
													</a>
												</h6>
											</div>
										</div>
									</div>
								</div>
							</Col>
							<Col xl={6} lg={6} sm={12} xs={12} md={12}>
								<div>
									<img src={imgCDNURL + "tele.webp"} className="teleimg" alt="Telephone" />
									<img src={imgCDNURL + "telemob.webp"} className="telemobimg" alt="Mobile" />
									<h3 className='teletext'>
										<a className='bluetext' href={"tel:+1" + Myuser.LOcontact}>
											{Myuser.LOcontact}
										</a>
									</h3>
								</div>
							</Col>
						</Row>
					</Container>
					<div>
						<p className="disclaimer2">
							Jason Oppenheim and Josh Altman are paid spokesmen for <a href="https://celligence.com/" target="_blank" rel="noopener noreferrer">Celligence International, LLC</a>, the creators of AngelAi. <br /><br />Ivan Rodriguez is a paid spokesperson for <a href="https://www.swmc.com/" target="_blank" rel="noopener noreferrer">Sun West Mortgage Company, Inc.</a>
						</p>
					</div>
					<div className='telediv'>
						<h3 className='thankyoutext'>Thank you for considering Sun West Mortgage Company, Inc. for your financing needs. We look forward to working with you.</h3>
					</div>
				</div>
			)}
		</>
	);
}